import { SText } from '@setvi/shared/components';
import { Product } from '@setvi/shared/interfaces';

interface LineProps {
  product: Product;
}

export const Line = ({ product }: LineProps) => (
  <SText
    title={
      // @ts-ignore
      product?.custom?.line || '-'
    }
  />
);
